<ng-container *ngIf="facetValues$ | async as facetValues">
  <rrs-accordion
    *ngIf="shouldDisplayFacet || !!!(isDesktop$ | async)"
    class="facet"
    data-cy="facet"
    [defaultExpanded]="isDesktop$ | async">
    <accordion-item>
      <ng-template accordionHeader let-toggle="toggle">
        <div
          (click)="toggle()"
          (keydown.enter)="toggle()"
          tabindex="0"
          class="facet__header d-flex align-items-center justify-content-between mb-lg-3"
          role="button"
          [attr.aria-label]="
            'rrs.productFacetNavigation.filterBy.name'
              | cxTranslate : { name: facet.name }
          ">
          <h5 class="facet__title text-uppercase fw-light text-black fs-6 mb-1">
            {{ getTranslationKey(facet.name) | cxTranslate }}
          </h5>
          <rrs-icon
            [icon]="iconTypeList.CHEVRON_RIGHT"
            [size]="12"
            class="d-lg-none"></rrs-icon>
        </div>
      </ng-template>
      <ng-template accordionContent>
        <div class="facet__body">
          <div
            *ngIf="isSearchableFacet()"
            class="facet-searchbox my-3 ps-2 pe-3 py-1">
            <input
              class="facet-searchbox__input"
              [formControl]="searchInput"
              [attr.aria-label]="
                'rrs.productFacetNavigation.searchBy.name'
                  | cxTranslate : { name: facet.name }
              " />
            <div class="d-flex">
              <rrs-icon
                [icon]="iconTypeList.SEARCH"
                [size]="16"
                class="facet-searchbox__icon"></rrs-icon>
            </div>
          </div>
          <ul
            class="list-none"
            [class.facet__list--scrollable]="isScrollableFacet()">
            <ng-container *ngIf="!isSizeFacet(); else sizeFacetTemplate">
              <li *ngFor="let value of facetValues" class="lh-20px">
                <ng-container
                  [ngTemplateOutlet]="facetValue"
                  [ngTemplateOutletContext]="{
                    value: value,
                    facet: facet
                  }"></ng-container>
              </li>
            </ng-container>
          </ul>
          <ng-template #sizeFacetTemplate>
            <li
              *ngFor="let sizeFacet of facetValues; let last = last"
              [class.border-bottom]="!last">
              <rrs-accordion
                class="facet-size"
                [defaultExpanded]="isDesktop$ | async">
                <accordion-item>
                  <ng-template accordionHeader let-toggle="toggle">
                    <div
                      (click)="toggle()"
                      (keydown.enter)="toggle()"
                      tabindex="0"
                      class="facet-size__header d-flex align-items-center justify-content-between py-2 my-2">
                      <h6 class="m-0 facet-size__accordion-title">
                        {{ getTranslationKey(sizeFacet.name) | cxTranslate }}
                      </h6>
                      <rrs-icon
                        class="facet-size__accordion-icon"
                        [icon]="iconTypeList.CHEVRON_DOWN"
                        [size]="12"></rrs-icon>
                    </div>
                  </ng-template>
                  <ng-template accordionContent>
                    <ul
                      *ngIf="sizeFacet.values?.length"
                      class="list-none btn-group pb-3">
                      <li *ngFor="let value of sizeFacet.values">
                        <ng-container
                          [ngTemplateOutlet]="facetValue"
                          [ngTemplateOutletContext]="{
                            value: value,
                            facet: sizeFacet
                          }"></ng-container>
                      </li>
                    </ul>
                    <ng-container *ngIf="sizeFacet.subgroups?.length">
                      <div
                        *ngFor="let subgroup of sizeFacet.subgroups"
                        class="mb-2">
                        <h6 class="facet-size__subgroup-title">
                          {{ getTranslationKey(subgroup.name) | cxTranslate }}
                        </h6>
                        <ul class="list-none btn-group pb-3">
                          <li *ngFor="let value of subgroup.values">
                            <ng-container
                              [ngTemplateOutlet]="facetValue"
                              [ngTemplateOutletContext]="{
                                value: value,
                                facet: subgroup
                              }"></ng-container>
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                  </ng-template>
                </accordion-item>
              </rrs-accordion>
            </li>
          </ng-template>
        </div>
      </ng-template>
    </accordion-item>
  </rrs-accordion>
</ng-container>
<ng-template #facetValue let-facet="facet" let-value="value">
  <a
    *ngIf="isDesktop"
    #facetValue
    [id]="value.name"
    [routerLink]="
      {
        cxRoute: 'search',
        params: { query: currentSearchQuery }
      } | cxUrl
    "
    (click)="dispatchFacetChangeEvent(facet, value.name, value.selected)"
    [queryParams]="getLinkParams(value)"
    queryParamsHandling="merge"
    class="facet__value"
    [class.selected]="value.selected"
    [class.btn-size--active]="value.selected"
    [ngClass]="{ 'btn btn-size': isSizeFacet() }"
    [cxFocus]="{ key: value.name }"
    (keydown.space)="openLink($any($event))"
    [attr.role]="facet.multiSelect ? 'checkbox' : null"
    [attr.aria-label]="value.name"
    [attr.aria-checked]="facet.multiSelect ? value.selected : null"
    tabindex="0">
    <span *ngIf="isSizeFacet(); else defaultFacetValues" class="lh-sm">
      {{ value.name }}
    </span>

    <ng-template #defaultFacetValues>
      <div
        *ngIf="facet.multiSelect || !value.selected"
        class="facet-value d-flex align-items-end"
        [ngClass]="facet.multiSelect ? 'mb-1' : 'mb-0'">
        <div [ngClass]="facet.multiSelect ? 'form-check mb-0' : 'pl-0'">
          <input
            *ngIf="facet.multiSelect"
            class="form-check-input"
            type="checkbox"
            value=""
            id="{{ value.name }}"
            [checked]="value.selected"
            (change)="onCheckboxChange(facet, $event, value)" />
          <label class="form-check-label facet-value__label" [for]="value.name">
            <span
              [class.hover-underline]="!facet.multiSelect"
              *ngIf="!isSpecialCaseFacet()"
              aria-hidden="true">
              {{ value.name }}
            </span>
            <span *ngIf="isRatingFacet()">
              <rrs-star-rating
                [disabled]="true"
                size="1.5rem"
                [rating]="$any(value.name)"></rrs-star-rating>
            </span>
            <span aria-hidden="true" class="facet__count">{{
              value.count
            }}</span>
          </label>
        </div>
      </div>
    </ng-template>
  </a>
  <a
    *ngIf="!isDesktop"
    #facetValue
    [id]="value.name"
    (click)="dispatchFacetChangeEvent(facet, value, value.selected)"
    class="facet__value"
    [class.selected]="isSelected(value, facet)"
    [class.btn-size--active]="isSelected(value, facet)"
    [ngClass]="{ 'btn btn-size': isSizeFacet() }"
    [cxFocus]="{ key: value.name }"
    (keydown.space)="openLink($any($event))"
    [attr.role]="
      facet.multiSelect || !!!(isDesktop$ | async) ? 'checkbox' : null
    "
    [attr.aria-label]="value.name"
    [attr.aria-checked]="facet.multiSelect ? isSelected(value, facet) : null"
    tabindex="0">
    <span *ngIf="isSizeFacet(); else defaultFacetValues" class="lh-sm">
      {{ value.name }}
    </span>

    <ng-template #defaultFacetValues>
      <div
        *ngIf="facet.multiSelect || !!!(isDesktop$ | async) || !value.selected"
        class="facet-value d-flex align-items-end"
        [ngClass]="facet.multiSelect ? 'mb-1' : 'mb-0'">
        <div [ngClass]="facet.multiSelect ? 'form-check mb-0' : 'pl-0'">
          <input
            *ngIf="facet.multiSelect"
            class="form-check-input"
            type="checkbox"
            [id]="value.name + 'checkbox'"
            (click)="$event.stopPropagation()"
            [checked]="isSelected(value, facet)"
            (change)="
              $event.stopPropagation(); onCheckboxChange(facet, $event, value)
            " />
          <label
            (click)="facet.multiSelect && $event.stopPropagation()"
            (keydown.space)="facet.multiSelect && $event.stopPropagation()"
            class="form-check-label facet-value__label"
            [for]="facet.multiSelect ? value.name + 'checkbox' : value.name"
            [class.fw-bold]="isSelected(value, facet)">
            <span
              [class.hover-underline]="!facet.multiSelect"
              *ngIf="!isSpecialCaseFacet()"
              aria-hidden="true">
              {{ value.name }}
            </span>
            <span *ngIf="isRatingFacet()">
              <rrs-star-rating
                [disabled]="true"
                size="1.5rem"
                [rating]="$any(value.name)"></rrs-star-rating>
            </span>
            <span aria-hidden="true" class="facet__count">{{
              value.count
            }}</span>
          </label>
        </div>
      </div>
    </ng-template>
  </a>
</ng-template>
